$(function() {
  'use strict';

  var $scrolls = $('.js-horizontal-scroll'),
      $html = $('html');

  $scrolls.each(function (index, scroll) {
    var $scroll = $(scroll),
        $container = $scroll.find('.js-horizontal-scroll-container'),
        scrollLeft = 0;

    $scroll.scrollLeft(scrollLeft);

    $scroll.on('wheel mousewheel', function(event) {

      if(event.originalEvent.wheelDelta) {;
        scrollLeft += -event.originalEvent.wheelDelta / 3;
      } else {
        scrollLeft += event.originalEvent.deltaY * 30;
      }

      scrollLeft = Math.min(scrollLeft, $container.outerWidth() - $scroll.width());
      scrollLeft = Math.max(scrollLeft, 0);

      scroll.scrollLeft = scrollLeft;
    });

  });

  if($scrolls.length > 0) {
    $html.addClass('has-horizontal-scroll');
  }

});
